export function extractLabels(data) {
    let labels = {}

    function recursiveExtract(obj) {
        if (Array.isArray(obj)) {
            obj.forEach((item) => recursiveExtract(item))
        } else if (typeof obj === 'object' && obj !== null) {
            if (obj.labels) {
                obj.labels.forEach((label) => {
                    labels[label.key] = {defaultMessage: label.value}
                })
            }
            if (obj.siblings) {
                recursiveExtract(obj.siblings)
            }
        }
    }

    recursiveExtract(data)
    return labels
}
